export const CREATE_BOOKING = "[BOOKING] CREATE";
export const UPDATE_BOOKING = "[BOOKING] UPDATE";
export const DELETE_BOOKING = "[BOOKING] DELETE";
export const AVGBOOKINGS_BOOKING = "[BOOKING] AVGBOOKINGS";

export const createBooking = (payload) => ({
  //always caps
  type: CREATE_BOOKING,
});

export const updateBooking = (payload) => ({
  //always caps
  type: UPDATE_BOOKING,
  payload: payload,
});

export const deleteBooking = (payload) => ({
  //always caps
  type: DELETE_BOOKING,
  payload: payload,
});

export const setBookingAverage = (payload) => ({
  type: AVGBOOKINGS_BOOKING,
  payload: payload,
});
